import { render, staticRenderFns } from "./WebHeader.vue?vue&type=template&id=ca8800a8&scoped=true"
import script from "./WebHeader.vue?vue&type=script&lang=js"
export * from "./WebHeader.vue?vue&type=script&lang=js"
import style0 from "./WebHeader.vue?vue&type=style&index=0&id=ca8800a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8800a8",
  null
  
)

export default component.exports